import React, { useEffect, useState } from "react";
import Header from "../header/header";
import FooterComponent from "../footerComponent/footerComponent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import committeeProfileImg from "../../assets/committeeProfileImg.png";
import "./profiles.scss";
import { useNavigate } from "react-router";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../variables";
import { convertBirthTime } from "../../sharedFunctions";
import CancelIcon from "@mui/icons-material/Cancel";
import ProfileDetails from "./profileDetails";
import Loader from "../shared/loader/loader";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const ProfilesHome = () => {
  let { type, gender } = useParams();
  const theme = useTheme();
  const [value, setValue] = useState(gender === "male" ? 0 : 1);
  const [showFilterSection, setShowFilterSection] = useState(false);
  let navigate = useNavigate();
  const [searchResults, setSearchResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [profile, setProfile] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [searchByFilters, setSearchByFilterValues] = useState(false);
  const [advanceSearchValues, setAdvanceSearchValues] = useState({
    education: "",
    country: "",
    state: "",
    city: "",
    status: "active",
    gender: gender,
    maritial_status: type,
  });

  useEffect(() => {
    function handleContextMenu(e) {
      e.preventDefault(); // prevents the default right-click menu from appearing
    }
    // add the event listener to the component's root element
    const rootElement = document.getElementById('profiles-component');
    rootElement.addEventListener('contextmenu', handleContextMenu);
    // remove the event listener when the component is unmounted
    return () => {
      rootElement.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  const searchById = (value) => {
    let tempArr = searchResults.filter((item) => {
      if (item.member_id?.toUpperCase().includes(value)) return item;
    });
    setFilteredResults(tempArr);
  };

  const handleChange = (Event, newValue) => {
    console.log(Event.target.value);
    console.log(newValue);
    setValue(newValue);
    setPageNo(1);
  };

  // useEffect(() => {
  //   getProfiles();
  // }, [pageNo]);

  useEffect(() => {
    setPageNo(1);
  }, [type]);

  useEffect(() => {
    if (!searchByFilters) getProfiles();
    else callSearchByFilters();
  }, [value, gender, pageNo, searchByFilters]);

  const getProfiles = async () => {
    setShowLoader(true);
    let res = await axios.post(
      API_URL +
        "getmemberspages?status=active&gender=" +
        (value == 0 ? "male" : "female") +
        "&maritial_status=" +
        type +
        "&page=" +
        pageNo +
        "&limit=10"
    );
    if (res?.data.body.length > 0) {
      setShowLoader(false);
      setSearchResults(res?.data.body);
      setFilteredResults(res?.data.body);
      setShowNoData(false);
    } else {
      setShowLoader(false);
      setSearchResults([]);
      setShowNoData(true);
      setFilteredResults([]);
    }
  };

  // const getProfilesInTab = async () => {
  //   let res = await axios.post(
  //     API_URL +
  //       "getmemberspages?status=active&gender=" +
  //       gender +
  //       "&maritial_status=" +
  //       type +
  //       "&page=" +
  //       pageNo +
  //       "&limit=10"
  //   );
  //   if (res?.data.body.length > 0) {
  //     setSearchResults(res?.data.body);
  //     setFilteredResults(res?.data.body);
  //     setShowNoData(false);
  //   } else {
  //     setSearchResults([]);
  //     setShowNoData(true);
  //     setFilteredResults([]);
  //   }
  // };

  const callSearchByFilters = async () => {
    // let res = await axios.post(
    //   API_URL + "searchmember?data=" + JSON.stringify(advanceSearchValues)
    // );
    setShowLoader(true);
    let res = await axios.post(
      API_URL +
        "getmemberspages?status=active&gender=" +
        (value == 0 ? "male" : "female") +
        "&maritial_status=" +
        type +
        "&education=" +
        advanceSearchValues.education +
        "&country=" +
        advanceSearchValues.country +
        "&state=" +
        advanceSearchValues.state +
        "&city=" +
        advanceSearchValues.city +
        "&page=" +
        pageNo +
        "&limit=10"
    );
    if (res?.data.body.length > 0) {
      setSearchResults(res?.data.body);
      setFilteredResults(res?.data.body);
      setShowNoData(false);
      setShowLoader(false);
    } else {
      setSearchResults([]);
      setShowNoData(true);
      setFilteredResults([]);
      setShowLoader(false);
    }
    setShowFilterSection(false);
  };

  // const resetFilters = async () => {
  //   let obj = {
  //     education: "",
  //     country: "",
  //     state: "",
  //     city: "",
  //     status: "active",
  //     gender: gender,
  //     maritial_status: type,
  //   };
  //   let res = await axios.post(
  //     API_URL + "searchmember?data=" + JSON.stringify(obj)
  //   );
  //   if (res?.data.body.length > 0) {
  //     setSearchResults(res?.data.body);
  //     setFilteredResults(res?.data.body);
  //     setShowNoData(false);
  //   } else {
  //     setSearchResults([]);
  //     setShowNoData(true);
  //     setFilteredResults([]);
  //   }
  //   setShowFilterSection(false);
  // };

  return (
    <>
      <Loader show={showLoader} />
      <Header />
      <section className="p-4 formSection bg-white mt-4" id='profiles-component'>
        <div className="">
          <label className="headerLabel pl-3 mb-3">
            <span className="text-capitalize">{type}</span> Profiles
          </label>
          <div className="float-right d-inline">
            <input
              type="text"
              className="p-2 searchBox mr-3"
              placeholder="Search by ID"
              value={searchId}
              onChange={(event) => {
                setSearchId(event.target.value);
                searchById(event.target.value);
              }}
            />
            <span className="textDarkRed">Advance Filters</span>
            <FilterAltIcon
              className="textDarkRed filterIcon cursorPointer"
              onClick={() => {
                setShowFilterSection(!showFilterSection);
                setSearchId("");
              }}
            />
          </div>
        </div>

        {showFilterSection && (
          <div className="filterSection p-3">
            <div className="textDarkRed text-right">
              <CloseIcon
                className="cursorPointer"
                onClick={() => {
                  setShowFilterSection(false);
                }}
              />
            </div>
            <div className="row">
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel text-left">
                    Education / शिक्षण
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Country"
                    value={advanceSearchValues.education}
                    onChange={(event) => {
                      setAdvanceSearchValues((prev) => ({
                        ...prev,
                        education: event.target.value,
                      }));
                    }}
                  />
                  {/* <Select
                    value={advanceSearchValues.education}
                    className="text-left"
                    onChange={(event) => {
                      setAdvanceSearchValues((prev) => ({
                        ...prev,
                        education: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="12th">10th</MenuItem>
                    <MenuItem value="12th">12th</MenuItem>
                    <MenuItem value="diploma">Diploma</MenuItem>
                    <MenuItem value="graduate">Graduate</MenuItem>
                    <MenuItem value="post graduate">Post - Graduate</MenuItem>
                    <MenuItem value="doctor">Doctor</MenuItem>
                    <MenuItem value="engineer">Engineer / PG Engg</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </Select> */}
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel text-left">
                    Country / व्यवसाय देश
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Country"
                    value={advanceSearchValues.country}
                    onChange={(event) => {
                      setAdvanceSearchValues((prev) => ({
                        ...prev,
                        country: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel text-left">
                    State / राज्य
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Country"
                    value={advanceSearchValues.state}
                    onChange={(event) => {
                      setAdvanceSearchValues((prev) => ({
                        ...prev,
                        state: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel text-left">
                    City / शहर
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Country"
                    value={advanceSearchValues.city}
                    onChange={(event) => {
                      setAdvanceSearchValues((prev) => ({
                        ...prev,
                        city: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
            </div>
            <div className="text-right">
              <Button
                size="large"
                variant="contained"
                className="buttonClass mr-3"
                onClick={() => {
                  setSearchByFilterValues(true);
                  setPageNo(1);
                }}
              >
                Apply
              </Button>
              <Button
                size="large"
                variant="contained"
                className="buttonClass"
                onClick={() => {
                  setAdvanceSearchValues((prev) => ({
                    ...prev,
                    education: "",
                    country: "",
                    state: "",
                    city: "",
                  }));
                  setShowFilterSection(false)
                  setSearchByFilterValues(false);
                  setPageNo(1);
                }}
              >
                Reset
              </Button>
            </div>
          </div>
        )}
        <Box sx={{ bgcolor: "background.paper" }} className="tabsWrapper">
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
              className="profileTabs"
            >
              <Tab label="Groom" {...a11yProps(0)} />
              <Tab label="Bride" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <TabPanel
            value={value}
            index={0}
            dir={theme.direction}
            className="tabPanelTemp"
          >
            <div className="row searchResultsSection profiles">
              {showNoData && (
                <div className="textDarkRed font18px font-bold text-center">
                  No data present
                </div>
              )}
              {filteredResults?.map((item, index) => {
                return (
                  <div key={index} className="col-md-6 p-2">
                    <div className="profileWrapper d-flex justify-content-start">
                      <div className="w-25 d-flex justify-content-center align-items-center profileDataView">
                        <img
                          alt=""
                          className="profileImg pe-none"
                          src={`data:image/jpeg;base64,${item.images[0]}`}
                        />
                      </div>
                      <div className="w-75 profileData">
                        <div>
                          <div className="">
                            <div className="id p-2 d-flex justify-content-between align-items-center">
                              <label className="textDarkRed mb-0 ">
                                <span>
                                  Register No / नोंदणी क्रv-
                                  <span className="font-bold">
                                    {item.member_id} (
                                    {item.last_name.toUpperCase()})
                                  </span>
                                </span>
                              </label>
                              <label
                                className="textDarkRed pt-3 hyperLink mr-3"
                                onClick={() => {
                                  setProfile(item);
                                  setShowDetails(true);
                                  //navigate("/profilesDetails/" + item.member_id);
                                }}
                              >
                                View Profile
                              </label>
                            </div>
                          </div>
                          <div className="details p-1">
                            <div className="row pt-3 p-2">
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Last Name / आडनाव
                                </label>
                                <label className="textDarkRed font-bold text-capitalize">
                                  {item.last_name}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  DOB / जन्मतारीख
                                </label>
                                <label className="textDarkRed font-bold">
                                  {item.dob}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Rashi / राशी
                                </label>
                                <label className="textDarkRed font-bold text-capitalize">
                                  {item.rashi.toUpperCase() === "NA"
                                    ? "-"
                                    : item.rashi}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Birth Time / जन्मस्वेळ
                                </label>
                                <label className="textDarkRed font-bold">
                                  {convertBirthTime(item.birth_time)}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Height / उंची (ft: inch)
                                </label>
                                <label className="textDarkRed font-bold">
                                  {item.heightFt ? item.heightFt + " feet" : ""}{" "}
                                  {item.heightInch
                                    ? item.heightInch + " inches"
                                    : ""}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Education / शिक्षण
                                </label>
                                <label className="textDarkRed font-bold">
                                  {item.education.toUpperCase()}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  City /नोकरी शहर
                                </label>
                                <label className="textDarkRed font-bold text-capitalize">
                                  {item.city}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Income / उत्पन्न
                                </label>
                                <label className="textDarkRed font-bold">
                                  Rs. {item.income_amt} {item.income_type}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {filteredResults?.length > 0 && (
                <div className="d-flex align-items-center justify-content-center p-3 w-100">
                  <ArrowCircleLeftIcon
                    className="inline-block mr-4 textDarkRed font22px arrowForPageChange"
                    onClick={() => {
                      if (pageNo > 1) setPageNo(pageNo - 1);
                    }}
                  />
                  <ArrowCircleRightIcon
                    className="inline-block  textDarkRed font22px arrowForPageChange"
                    onClick={() => {
                      setPageNo(pageNo + 1);
                    }}
                  />
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel
            value={value}
            index={1}
            dir={theme.direction}
            className="tabPanelTemp"
          >
            <div className="row searchResultsSection profiles">
              {showNoData && (
                <div className="textDarkRed font18px font-bold text-center">
                  No data present
                </div>
              )}
              {filteredResults?.map((item, index) => {
                return (
                  <div key={index} className="col-md-6 p-2">
                    <div className="profileWrapper d-flex justify-content-start">
                      <div className="w-25 d-flex justify-content-center align-items-center profileDataView">
                        <img
                          alt=""
                          className="profileImg"
                          src={`data:image/jpeg;base64,${item.images[0]}`}
                        />
                      </div>
                      <div className="w-75 profileData">
                        <div>
                          <div className="">
                            <div className="id p-2 d-flex justify-content-between align-items-center">
                              <label className="textDarkRed mb-0 ">
                                <span>
                                  Register No / नोंदणी क्रv-
                                  <span className="font-bold">
                                    {item.member_id} (
                                    {item.last_name.toUpperCase()})
                                  </span>
                                </span>
                              </label>
                              <label
                                className="textDarkRed pt-3 hyperLink mr-3"
                                onClick={() => {
                                  setProfile(item);
                                  setShowDetails(true);
                                }}
                              >
                                View Profile
                              </label>
                            </div>
                          </div>
                          <div className="details p-1">
                            <div className="row pt-3 p-2">
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Last Name / आडनाव
                                </label>
                                <label className="textDarkRed font-bold text-capitalize">
                                  {item.last_name}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  DOB / जन्मतारीख
                                </label>
                                <label className="textDarkRed font-bold">
                                  {item.dob}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Rashi / राशी
                                </label>
                                <label className="textDarkRed font-bold text-capitalize">
                                  {item.rashi.toUpperCase() === "NA"
                                    ? "-"
                                    : item.rashi}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Birth Time / जन्मस्वेळ
                                </label>
                                <label className="textDarkRed font-bold">
                                  {convertBirthTime(item.birth_time)}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Height / उंची (ft: inch)
                                </label>
                                <label className="textDarkRed font-bold">
                                  {item.heightFt ? item.heightFt + " feet" : ""}{" "}
                                  {item.heightInch
                                    ? item.heightInch + " inches"
                                    : ""}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Education / शिक्षण
                                </label>
                                <label className="textDarkRed font-bold">
                                  {item.education.toUpperCase()}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  City /नोकरी शहर
                                </label>
                                <label className="textDarkRed font-bold text-capitalize">
                                  {item.city}
                                </label>
                              </div>
                              <div className="col-md-4 mb-2">
                                <label className="labelName mb-0">
                                  Income / उत्पन्न
                                </label>
                                <label className="textDarkRed font-bold">
                                  Rs. {item.income_amt} {item.income_type}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {filteredResults?.length > 0 && (
                <div className="d-flex align-items-center justify-content-center p-3 w-100">
                  <ArrowCircleLeftIcon
                    className="inline-block mr-4 textDarkRed font22px arrowForPageChange"
                    onClick={() => {
                      if (pageNo > 1) setPageNo(pageNo - 1);
                    }}
                  />
                  <ArrowCircleRightIcon
                    className="inline-block  textDarkRed font22px arrowForPageChange"
                    onClick={() => {
                      setPageNo(pageNo + 1);
                    }}
                  />
                </div>
              )}
            </div>
          </TabPanel>
        </Box>
        <Dialog
          open={showDetails}
          onClose={() => {
            setShowDetails(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="profileDetailsPopup"
        >
          <DialogActions>
            {/* <Button onClick={()=>{setShowDetails(false)}}>Close</Button> */}
            <CancelIcon
              onClick={() => {
                setShowDetails(false);
              }}
              className="cursorPointer"
            />
          </DialogActions>
          <DialogContent className="pt-0">
            <ProfileDetails
              profileData={profile}
              showAllDetailsByDefault={false}
              showGetContactBtn={true}
            />
          </DialogContent>
        </Dialog>
      </section>
      <FooterComponent />
    </>
  );
};
export default ProfilesHome;
